module.exports = new __parcel__URL__("mundo1.ea741957.png").toString();